import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { AddPhotoAlternate } from '@material-ui/icons'
import styled from 'styled-components'

const ImgPreview = styled.img`
  max-width: 100%;
  height: 50px;
  cursor: pointer;
`
const Input = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`
const Label = styled.label`
  cursor: pointer;
`
const LogoPlaceHolder = styled.div`
  background-color: ${props => props.theme.palette.divider};
  color: ${props => props.theme.palette.text.secondary};
  border-radius: 100%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ThemeLogoUpload = props => {
  const { theme, setTheme } = props

  // Uploading an image using the file reader
  const uploadFile = e => {
    e.preventDefault()

    const reader = new FileReader()
    const file = e.target.files[0]

    // Wait for image to load
    reader.onloadend = () => {
      const img = new Image()
      img.src = reader.result

      // Wait for the image to load
      // Check it is an image and size < 2mb
      img.addEventListener('load', () => {
        if (file.size > 2000000) {
          alert('Please ensure your file size is 2MB or less')
          return
        }

        if (!img.width) {
          alert('Please ensure your file is an image format')
          return
        }

        // Remove once custom themes created
        console.log(reader.result)

        // Set the logo to state
        setTheme(oldItems => ({
          ...oldItems,
          file,
          imagePreviewUrl: reader.result,
          imageWidth: img.width,
          imageHeight: img.height,
        }))
      })
    }

    if (file) {
      reader.readAsDataURL(file)
    }
  }
  return (
    <Box py={4} pl={8}>
      <Typography color="textSecondary">Add a logo</Typography>
      <Box py={4}>
        <Input
          type="file"
          id="file"
          name="file"
          placeholder="upload a logo"
          required
          onChange={uploadFile}
        />
        <Label htmlFor="file">
          {!theme.imagePreviewUrl && (
            <LogoPlaceHolder>
              <AddPhotoAlternate color="inherit" />
            </LogoPlaceHolder>
          )}
          {theme.imagePreviewUrl && (
            <ImgPreview src={theme.imagePreviewUrl} alt="Preview of logo" />
          )}
          {/* {logoImage && !logo.imagePreviewUrl && (
            <ImgPreview src={logoImage} alt="Preview of logo" />
          )} */}
        </Label>
      </Box>
    </Box>
  )
}

ThemeLogoUpload.propTypes = {
  theme: PropTypes.object,
  setTheme: PropTypes.func,
}

export default ThemeLogoUpload
